import '../styles/HeaderStyle.css'
import LoginLogout from '../login/LoginLogout';

function ProjectsHeader() {
    
  return (
    <div id='headerDiv'>
      <a href='/' id='backButton'>Go Back</a>
        <h1 id='title'>Projects</h1>
        <LoginLogout id="logoutButton"/>
    </div>
  )
}

export default ProjectsHeader